function convertAmountInWord(num: number): string {
  const singleDigits: string[] = [
    "",
    "one ",
    "two ",
    "three ",
    "four ",
    "five ",
    "six ",
    "seven ",
    "eight ",
    "nine ",
    "ten ",
    "eleven ",
    "twelve ",
    "thirteen ",
    "fourteen ",
    "fifteen ",
    "sixteen ",
    "seventeen ",
    "eighteen ",
    "nineteen ",
  ];
  const tensDigits: string[] = [
    "",
    "",
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety",
  ];

  const numString: string = num.toString();
  if (numString.length > 9) return "overflow";

  const paddedNumber: string = ("000000000" + numString).substr(-9);
  const matchArray: RegExpMatchArray | null = paddedNumber.match(
    /^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/
  );

  if (!matchArray) return "";

  let words: string = "";

  words +=
    matchArray[1] !== "00"
      ? (singleDigits[Number(matchArray[1])] ||
          tensDigits[Number(matchArray[1][0])] +
            " " +
            singleDigits[Number(matchArray[1][1])]) + "crore "
      : "";
  words +=
    matchArray[2] !== "00"
      ? (singleDigits[Number(matchArray[2])] ||
          tensDigits[Number(matchArray[2][0])] +
            " " +
            singleDigits[Number(matchArray[2][1])]) + "lakh "
      : "";
  words +=
    matchArray[3] !== "00"
      ? (singleDigits[Number(matchArray[3])] ||
          tensDigits[Number(matchArray[3][0])] +
            " " +
            singleDigits[Number(matchArray[3][1])]) + "thousand "
      : "";
  words +=
    matchArray[4] !== "0"
      ? (singleDigits[Number(matchArray[4])] ||
          tensDigits[Number(matchArray[4][0])] +
            " " +
            singleDigits[Number(matchArray[4][1])]) + "hundred "
      : "";
  words +=
    matchArray[5] !== "00"
      ? (words !== "" ? "and " : "") +
        (singleDigits[Number(matchArray[5])] ||
          tensDigits[Number(matchArray[5][0])] +
            " " +
            singleDigits[Number(matchArray[5][1])]) +
        "only "
      : "";

  return words.trim() + " " + "rupees only";
}

export default convertAmountInWord;
